const tooltips = {
  telefonszam: 'A telefonszám 8 vagy 9 számból állhat!',
};

export default function getTooltip(name) {
  return tooltips[name];
}
